import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Scale } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LegalDisclaimer } from "@/components/common/LegalDisclaimer";

export const LandingCTA = () => (
  <>
    <section className="mx-auto max-w-6xl px-4 pb-10 sm:px-6">
      <div className="overflow-hidden rounded-2xl bg-primary px-6 py-12 text-center text-primary-foreground sm:px-12">
        <h2 className="font-display text-3xl font-semibold tracking-tight">Make every booking a confident one.</h2>
        <p className="mx-auto mt-3 max-w-xl text-primary-foreground/80">
          Join Australian hosts using structured risk checks to protect their properties — the compliant way.
        </p>
        <Link to="/signup"><Button size="lg" variant="secondary" className="mt-6 gap-2" data-testid="cta-signup-button">Get started free <ArrowRight className="h-4 w-4" /></Button></Link>
      </div>
    </section>

    <section className="mx-auto max-w-4xl px-4 pb-16 sm:px-6">
      <div className="rounded-2xl border bg-card p-6 sm:p-8">
        <div className="mb-3 flex items-center gap-2">
          <Scale className="h-4 w-4 text-primary" />
          <h3 className="font-display text-base font-semibold">A note on responsible use</h3>
        </div>
        <LegalDisclaimer compact />
      </div>
    </section>
  </>
);
